import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { StepPageWrapper } from '@Layout/StepPageWrapper';
import { useNonprofitDescriptionELogic } from './hooks/useNonprofitDescriptionELogic';
import { NonprofitDescriptionEForm } from './NonprofitDescriptionEForm';

export const EddNonprofitDescriptionE = () => {
  const { t } = useTranslation('eddQuestions');
  const { t: tCommon } = useTranslation();
  const { formMethods, handleSubmit, isLoading } = useNonprofitDescriptionELogic();

  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        isLoading={isLoading}
        formMethods={formMethods}
        handleSubmit={handleSubmit}
        heading={tCommon('sectionTitles.businessDetails')}
        text={t('organic.nonprofitDescriptionE.content')}
        textCustomStyle='text-text-main-primary text-[16px] whitespace-pre-line'
        content={t('organic.nonprofitDescriptionE.title')}>
        <NonprofitDescriptionEForm />
      </StepPageWrapper>
    </FormProvider>
  );
};
